export default ({
  handler,
  defaultHandler,
  arrayHandler,
  multiSelect,
}) => {
  if (handler) {
    return handler;
  }
  if (multiSelect && arrayHandler) {
    return arrayHandler;
  }
  return defaultHandler;
};
